import React, { useEffect } from "react";
import NewHeader from "@/components/NewHeader";
import SEO from "@/components/SEO";
import HeroCarousel from "@/components/HeroCarousel";
import HomeGastro from "@/components/HeroContentSection";
import USPStrip from "@/components/USPStrip";
import { RoomGalleryCarousel } from "@/components/ui/room-gallery-carousel";
import { RestaurantGalleryCarousel } from "@/components/ui/restaurant-gallery-carousel";
import { WellnessGalleryCarousel } from "@/components/ui/wellness-gallery-carousel";
import GymPoolSection from "@/components/GymPoolSection";
import IMAXTheatreSection from "@/components/IMAXTheatreSection";
import EventsSection from "@/components/EventsSection";
import LocalAttractions from "@/components/LocalAttractions";
import MomentsOfJoy from "@/components/MomentsOfJoy";
import JournalPreviewSection from "@/components/journal/JournalPreviewSection";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";
import { ExitIntentPopup } from "@/components/booking/ExitIntentPopup";
import { SocialProofToast } from "@/components/booking/SocialProofToast";
import { useLanguage } from "@/contexts/LanguageContext";
import { getPageSEO, SEOLanguage } from "@/data/seoTranslations";
import { getTranslatedStructuredData } from "@/data/structuredDataTranslations";

const Index = () => {
  const { language, t } = useLanguage();
  const seoLang = language as SEOLanguage;
  const seoData = getPageSEO("home", seoLang);

  // Generate Review Schema
  const reviewSchema = {
    "@context": "https://schema.org",
    "@type": "Hotel",
    "name": "Beatenberg Resort & Spa",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.2",
      "reviewCount": "245",
      "bestRating": "5",
      "worstRating": "1"
    },
    "review": [
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": t("testimonials.testimonial1.name")
        },
        "reviewBody": t("testimonials.testimonial1.quote"),
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        }
      },
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": t("testimonials.testimonial2.name")
        },
        "reviewBody": t("testimonials.testimonial2.quote"),
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        }
      },
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": t("testimonials.testimonial3.name")
        },
        "reviewBody": t("testimonials.testimonial3.quote"),
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        }
      }
    ]
  };

  // Handle deep linking to sections
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          // Add a small delay to ensure all components are loaded
          setTimeout(() => {
            element.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }, 500);
        }
      }
    };

    // Handle initial load with hash
    handleHashChange();

    // Handle hash changes
    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  return (
    <div className="min-h-screen pb-20 lg:pb-0">
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        canonical="/"
        language={seoLang}
        structuredData={[
          getTranslatedStructuredData.business(seoLang),
          getTranslatedStructuredData.website(seoLang),
          getTranslatedStructuredData.organization(seoLang),
          reviewSchema,
        ]}

      />

      <NewHeader />
      <main className="relative pt-8">
        <HeroCarousel />
        <div
          className="relative z-20 bg-white mt-[100vh]"
          style={{
            minHeight: "100vh",
            isolation: "isolate",
            transform: "translateZ(0)",
            backfaceVisibility: "hidden",
          }}
        >
          <HomeGastro />
          <USPStrip />
          <RoomGalleryCarousel />
          <RestaurantGalleryCarousel />
          <WellnessGalleryCarousel />
          <GymPoolSection />
          <IMAXTheatreSection />
          <EventsSection />
          <LocalAttractions />
          <div id="moments-of-joy">
            <MomentsOfJoy />
          </div>
          <JournalPreviewSection />
          <CTASection />
        </div>
        <ExitIntentPopup />
        <SocialProofToast />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
